module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_vm._m(0), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "abst"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE "), _c('big', [_vm._v("SAVEUR")]), _vm._v(" TEST KITCHEN HAS SEEN")], 1), _vm._v(" thousands upon thousands of recipes pass through its ovens and over its stovetops over the years. We rigorously test each recipe multiple times, using consistent methods. As you cook through this book, here are a few things worth keeping in mind.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Always read a recipe start to finish before beginning to cook, to familiarize yourself with the ingredients and techniques, and to get a sense of how long the recipe will take. Some recipes have Cook’s Notes at the end; these are there to help you with a particular technique, help you source an ingredient or tool, or give you options for modifying the recipe.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If a recipe specifies a pot or pan of a certain size (like a 6-qt. saucepan or 10” skillet), use a comparable vessel in order to maintain the integrity of the recipe. Too small a pan, and you may end up steaming chicken rather than searing it; too big a pot, and you may over-reduce a sauce because there’s too much surface area.")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We specify water in an ingredient list only if it needs to be heated or chilled to a specific temperature, or if a recipe demands filtered or distilled water that needs to be acquired ahead of time. Otherwise, you’ll find water listed in the instructions.")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With a few exceptions, our recipes are tested using kosher salt, which tastes better and dissolves faster than table salt.")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pre-ground black pepper rarely stands up to the bite or fragrance of its fresh counterpart. Invest in a pepper grinder and whole peppercorns, and grind your pepper as you need it.")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We believe butter should add fat and flavor, but not a briny bite—that’s salt’s job. So unless specified, we use only unsalted butter in our recipes.")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For frying and sautéing, our preferred neutral oil is canola. Some recipes benefit from olive oil; when its grassy flavor shines, we use extra-virgin, but if the ingredients don’t specify, the standard variety is sufficient. Some recipes call for Asian sesame oil, also sold as “toasted sesame oil.” Be sure not to use light sesame oil; the flavor is very different.")])]), _vm._m(8), _vm._m(9), _vm._m(10)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('a', {
    attrs: {
      "id": "a2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("HOW TO USE THIS BOOK"), _c('br'), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "left_s"
  }, [_c('b', [_vm._v("RECIPES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "left_s"
  }, [_c('b', [_vm._v("COOKING EQUIPMENT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "left_s"
  }, [_c('b', [_vm._v("WATER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "left_s"
  }, [_c('b', [_vm._v("SALT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "left_s"
  }, [_c('b', [_vm._v("PEPPER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "left_s"
  }, [_c('b', [_vm._v("BUTTER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "left_s"
  }, [_c('b', [_vm._v("OIL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "left_s"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('b', [_vm._v("PARSLEY")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Unless otherwise noted, we prefer flat-leaf (also known as Italian) parsley, rather than the curly variety, because flat-leaf has a cleaner flavor and texture.")]), _vm._v(" "), _c('p', {
    staticClass: "left_s"
  }, [_c('b', [_vm._v("TAMARIND")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In recipes that call for tamarind, we generally specify tamarind extract. To make tamarind extract, soak "), _c('b', [_vm._v("¼")]), _vm._v(" lb. tamarind paste, broken into small pieces, in 1 cup boiling water, occasionally mashing the pulp with your fingers. The strained liquid will keep in the refrigerator for up to 2 weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "left_s"
  }, [_c('b', [_vm._v("TOMATOES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To maintain quality and consistency when it comes to canned tomatoes, we use only whole, peeled tomatoes. We then crush, dice, or purée them as needed, with or without their juices. (Note that if a recipe calls for “canned whole tomatoes, crushed” and you substitute canned crushed tomatoes, the recipe may not turn out exactly.)")]), _vm._v(" "), _c('p', {
    staticClass: "left_s"
  }, [_c('b', [_vm._v("FLOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When a recipe refers to “flour,” we mean all-purpose flour. If a recipe calls for a certain variety—like cake flour, rice flour, or whole wheat flour—the ingredient list will specify. We measure flour by volume, using a consistent method: Use a spoon to stir the flour in its container. Transfer flour into a measuring cup one spoonful at a time until the cup overflows, then sweep a knife across the rim to make an even surface.")]), _vm._v(" "), _c('p', {
    staticClass: "left_s"
  }, [_c('b', [_vm._v("ALCOHOL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We test our cocktails using widely available national brands that are in the middle of the price spectrum. Avoid bargain-priced spirits; they’re often harsh and poorly balanced. When you’re cooking with liquor, always use something you’d be more than happy to drink on its own. The alcohol itself may cook off, but the flavor of the drink will remain in the finished dish.  ")]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('p', {
    staticClass: "line1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center_s"
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("TO MARKET,")]), _vm._v(" "), _c('span', {
    staticClass: "col3"
  }, [_vm._v("TO MARKET")])])]), _vm._v(" "), _c('p', {
    staticClass: "line2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box1"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "left_s1"
  }, [_vm._v("While most of the recipes in this book call for ingredients readily found at your favorite local supermarket—where you can increasingly find ingredients ranging from Thai rice noodles to dried Mexican chiles—in a few cases, you’ll need to look a bit further.")])]), _c('p', {
    staticClass: "left_s1"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("For hard-to-find packaged goods, the internet is your grocery store. There are countless specialty retailers with robust mail-order services online: Just plug your desired product into your favorite search engine and up will pop dozens of specialty retailers that ship quickly and affordably. (More often than not, what you’re looking for is right there on ")]), _c('a', {
    attrs: {
      "href": "http://amazon.com",
      "target": "_blank"
    }
  }, [_vm._v("amazon.com")]), _vm._v(".) For spices, extracts, and dried fruits and nuts we especially recommend Kalustyan’s ("), _c('a', {
    attrs: {
      "href": "http://kalustyans.com",
      "target": "_blank"
    }
  }, [_vm._v("kalustyans.com")]), _vm._v("); for hard-to-find produce, we usually order from Melissa’s ("), _c('a', {
    attrs: {
      "href": "http://melissas.com",
      "target": "_blank"
    }
  }, [_vm._v("melissas.com")]), _vm._v("); and for specialty meats, we turn to Marx Foods ("), _c('a', {
    attrs: {
      "href": "http://marxfoods.com",
      "target": "_blank"
    }
  }, [_vm._v("marxfoods.com")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "left_s1"
  }, [_vm._v("We also encourage you to seek out specialty grocery stores in your area. In most parts of the US, you can find stores specializing in Mexican, Asian, Indian and Caribbean foods, which can be an excellent source for hard-to- find ingredients—and usually at a lower price than what you will find online.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a3efea6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cap00b.vue
// module id = 69
// module chunks = 0